module.exports = __webpack_public_path__ + "media/images/emblems/GX-VD-Syens-f64b7e1215348d5bb1086630574b5ae0.png";